var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 1.83337C4.32667 1.83337 1.33333 4.82671 1.33333 8.50004C1.33333 12.1734 4.32667 15.1667 8 15.1667C11.6733 15.1667 14.6667 12.1734 14.6667 8.50004C14.6667 4.82671 11.6733 1.83337 8 1.83337ZM11.1867 6.96671L7.40667 10.7467C7.31333 10.84 7.18667 10.8934 7.05333 10.8934C6.92 10.8934 6.79333 10.84 6.7 10.7467L4.81333 8.86004C4.62 8.66671 4.62 8.34671 4.81333 8.15337C5.00667 7.96004 5.32667 7.96004 5.52 8.15337L7.05333 9.68671L10.48 6.26004C10.6733 6.06671 10.9933 6.06671 11.1867 6.26004C11.38 6.45337 11.38 6.76671 11.1867 6.96671Z",
    fill: "#1A99A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.d5a8c7f370d74308f0ae12a549a33f0e.svg";
export { ForwardRef as ReactComponent };